import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./pages/landing-page/landing-page.component').then((c) => c.LandingPageComponent),
    data: {
      breadcrumb: {
        label: 'landingpage',
      },
      seo: {
        title: 'seo.landing.title',
        description: 'seo.landing.description',
        ogImage: '/assets/images/og-landing.png',
        lcpImage: '/assets/images/landing/hero_section_880.webp',
        lcpImageSrcSet:
          '/assets/images/landing/hero_section_720.webp 720w, /assets/images/landing/hero_section_880.webp 880w, /assets/images/landing/hero_section_1280.webp 1280w, /assets/images/landing/hero_section.webp 2560w',
        lcpImageSizes: '(max-width: 768px) 100vw, (min-resolution: 120dpi) and (min-width: 769px) 800px, 1000px',
        lcpImageType: 'image/webp',
      },
    },
  },
  {
    path: 'imprint',
    loadComponent: () => import('./pages/imprint/imprint.component').then((c) => c.ImprintComponent),
    data: {
      breadcrumb: {
        label: 'imprint',
      },
      seo: {
        title: 'seo.imprint.title',
        description: 'seo.imprint.description',
      },
    },
  },
  {
    path: 'privacy',
    loadComponent: () => import('./pages/privacy/privacy.component').then((c) => c.PrivacyComponent),
    data: {
      breadcrumb: {
        label: 'privacy',
      },
      seo: {
        title: 'seo.privacy.title',
        description: 'seo.privacy.description',
      },
    },
  },
  {
    path: 'contact',
    loadComponent: () => import('./pages/contact/contact.component').then((c) => c.ContactComponent),
    data: {
      breadcrumb: {
        label: 'contact',
      },
      seo: {
        title: 'seo.contact.title',
        description: 'seo.contact.description',
      },
    },
  },
];
